import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ICurrentUser } from './types';
import { ROLES } from '../../../../../helpers/utils/auth';

const initialState: ICurrentUser = {
  id: -1,
  name: '',
  email: '',
  phone: '',
  role: ROLES.empty,
  global_role: '',
  school_id: null,
  telegram_connect: false,
  max_connect: false,
  messenger_connect: false,
  require_messenger: true,
  ownedSchool: [],
  isLoading: false,
  isUtm:false,
  isContact:false,
  isAdmin:false,
  main_dashboard: null,
};

export const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState: initialState,
  reducers: {
    setUtm: (state,action:PayloadAction<boolean>) => {
      state.isUtm = action.payload;
    },
    setContact:(state,action:PayloadAction<boolean>) => {
      state.isContact = action.payload;
    },
    setIsAdmin:(state,action:PayloadAction<boolean>) => {
      state.isAdmin = action.payload;
    },
    currentUserSetData: (state, action: PayloadAction<any>) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.phone = action.payload.phone;
      state.role = action.payload.role;
      state.global_role = action.payload.global_role;
      state.school_id = action.payload.school_id;
      state.ownedSchool = action.payload.ownedSchool;
      state.telegram_connect = action.payload.telegram_connect;
      state.max_connect = !!action.payload.max_connect;
      // Поля появились вместе с MAX. Если бэкенд ещё старый и их не прислал,
      // опираемся на telegram_connect: иначе пользователь с привязанным Telegram
      // считался бы непривязанным и упёрся бы в страницу привязки.
      state.messenger_connect = !!(action.payload.messenger_connect ?? action.payload.telegram_connect);
      state.require_messenger = action.payload.require_messenger ?? true;
      state.main_dashboard = action.payload.main_dashboard;
    },
    currentUserClearData: (state) => {
      state.id = initialState.id;
      state.name = initialState.name;
      state.email = initialState.email;
      state.phone = initialState.phone;
      state.role = initialState.role;
      state.global_role = initialState.global_role;
      state.school_id = initialState.school_id;
      state.ownedSchool = initialState.ownedSchool;
      state.telegram_connect = initialState.telegram_connect;
      state.max_connect = initialState.max_connect;
      state.messenger_connect = initialState.messenger_connect;
      state.require_messenger = initialState.require_messenger;
      state.main_dashboard = initialState.main_dashboard;
    },
    userSetLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const currentUserSliceActions = currentUserSlice.actions;
export const currentUserSliceReducer = currentUserSlice.reducer;
